import { useRef, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button.jsx';
import { readBrandImage } from '@/lib/brand-image.js';

// Partner logo picker for a keychain batch. `value` is the data URI (or '')
// and `onChange` receives the resized data URI, or '' when cleared. Renders
// the current logo so the broker sees what the landing page will show.
export default function BrandImageField({ id = 'brand-image', value, onChange }) {
  const fileRef = useRef(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function pick(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setError(''); setBusy(true);
    try {
      onChange(await readBrandImage(file));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  }

  return (
    <div>
      <label className="mb-1 block text-[11px] uppercase tracking-wide text-text-dim" htmlFor={id}>
        Partner logo <span className="text-text-dim/70 normal-case">(PNG, JPG or SVG, shown above the NDEMNIFLY wordmark)</span>
      </label>
      {value ? (
        <div className="flex items-center gap-3 rounded-card border border-border bg-surface p-2">
          <img src={value} alt="Partner logo" className="max-h-16 max-w-[200px] object-contain" />
          <Button type="button" variant="outline" size="xs" onClick={() => { onChange(''); setError(''); }}>
            <X size={12} /> Remove
          </Button>
        </div>
      ) : (
        <input
          ref={fileRef}
          id={id}
          type="file"
          accept="image/png,image/jpeg,image/svg+xml,image/webp"
          disabled={busy}
          onChange={pick}
          className="block w-full text-sm text-text-muted file:mr-3 file:rounded-md file:border file:border-border file:bg-surface file:px-3 file:py-1.5 file:text-xs file:text-text"
        />
      )}
      {error && <p className="mt-1 text-xs text-accent">{error}</p>}
    </div>
  );
}
